import React from 'react';
import { Link } from 'react-router-dom';
import { fmtPrice } from '../../utils/pricing';
import './StickyProductBar.css';

// Phone-only bar pinned to the bottom of a product page: the product, its
// "from" price and one action. Awnings go to the full configurator; anything
// else (pergolas, accessories) goes to the quote form. Desktop has the same
// actions in the sidebar, so the bar is display:none above phone width.
export default function StickyProductBar({ product, pricing }) {
  if (!product) return null;
  const configurable = product.category === 'awning' && (product.variant_prices || []).length > 0;
  const to = configurable ? `/configure/${product.slug}` : '/request-quote';
  const label = configurable ? 'Customise and price' : 'Request a quote';
  const shortName = product.name;

  return (
    <div className="spb" role="region" aria-label="Product actions">
      <div className="spb-text">
        <span className="spb-name">{shortName}</span>
        {pricing?.sale != null && (
          <span className="spb-price">from <strong>${fmtPrice(pricing.sale)}</strong></span>
        )}
      </div>
      <Link to={to} className="spb-btn">{label}</Link>
    </div>
  );
}
